import { restClient } from '@/Core'

import type { UserCardValues } from '../Contracts/IUser'

export type UserActivityStatus = 'active' | 'inactive'

/**
 * Активація й деактивація: `PATCH /services/users/{uuid}/change_status`
 * `{ status }` (ADR 038, `SPEC-005` §3.4). Діє одразу — без «Зберегти»; при
 * деактивації бек видаляє refresh-токени, і відкриті сесії людини гаснуть на
 * наступному запиті.
 *
 * Звичайний PATCH картки статусу не змінить: у групі запису його немає.
 */
export const ChangeUserStatusTask = async (uuid: string, status: UserActivityStatus): Promise<UserCardValues> => {
    const response = await restClient.patch(`/services/users/${encodeURIComponent(uuid)}/change_status`, {
        json: { status },
    })

    return (response ?? {}) as unknown as UserCardValues
}
